import "@progress/kendo-ui/js/kendo.angular";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.data";
import "@progress/kendo-ui/js/kendo.data.signalr";

import "@progress/kendo-ui/js/kendo.dataviz.core";
import "@progress/kendo-ui/js/kendo.dataviz.chart";

// import "@progress/kendo-ui/css/web/kendo.common.less";
// import "@progress/kendo-ui/css/web/kendo.materialblack.less";

import * as angular from "angular";
import { DASHBOARD_SERVICE, DashboardService } from "./dashboard.service";
import { configRoute } from "./dashboard.router";

import { DASHBOARD_DIALOG_SERVICE, DashboardDialogService } from "./dashboard-create-user-dialog.controller"

import coreModule from "../core/core.module";
import monitorModule from "../monitor/monitor.module";

export default angular
    .module("board.web.admin.dashboard", [
        coreModule.name,
        "kendo.directives",
        monitorModule
    ])
    .service(DASHBOARD_SERVICE, DashboardService)
    .service(DASHBOARD_DIALOG_SERVICE, DashboardDialogService)
    .config(configRoute)
    .name;


// WEBPACK FOOTER //
// ./app/dashboard/dashboard.module.ts